import React, { useEffect } from 'react';
import { useState } from "react";

import { useTranslation } from "react-i18next";
import { useApp } from '../../context/AppContext.jsx';
import { useSave } from '../../context/SaveContext.jsx';
import { DeckModal } from '../../component/ui/Window.jsx';
import { MyButton, MyDangerButton, MyPagination } from '../../component/ui/UI.jsx';
import { usePagination } from '@MyLib/UI/Pagination.jsx';
import { useAppNavigate } from '../Route.jsx';
import { useIsMobile } from "@MyLib/System/Mobile.js";

const DeckCanvas = ({ deck }) =>
{
	const { t } = useTranslation();
	const {gotoDeckBuilder} = useAppNavigate();
	const {setYesNoModal} = useApp();
	const {deckList, buildDeck, loadDeck, deleteDeck, saveDeckList} = useSave();

	const onClickDelete = (e) => {
		e.stopPropagation();
		setYesNoModal({
			title: 'デッキ削除',
			body: <div>{`${deck.name}を削除しますか?`}</div>,
			onClose: ()=>{
				setYesNoModal(null);
			},
			onSubmit: async () => {
				await deleteDeck(deck.id);
				const newDeckList = deckList.filter((item, i) => item.id != deck.id);
				await saveDeckList(newDeckList);
			}
		});
	};

	return (
		<div
			className="card p-1"
			style={{ cursor: "pointer" }}
			onClick={async () => {
				if (buildDeck === null || buildDeck.id !== deck.id)
				{
					const res = await loadDeck(deck.id);
					if (!res)
					{
						return;
					}
				}
				gotoDeckBuilder();
			}}
		>
			<div className="row g-1">
				<div className="col-auto">
				</div>
				<div className="col">
					<ul className="list-unstyled m-0">
						<li><strong>{deck.name}</strong></li>
						{/*<li>{deck.id}</li>*/}
					</ul>
				</div>
				<div
					className="col-auto ms-auto"
				>
					<ul className="list-unstyled m-0">
						<li>
							<MyDangerButton onClick={(e) => {onClickDelete(e)}} text={t("Common_Trash")} outline={true} />
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
};

export const MyDeck = () =>
{
	const { t } = useTranslation();
	const { deckList } = useSave();
	const [showModal, setShowModal] = useState(false);

	const {isMobile} = useIsMobile();
	const page = usePagination({limit:10, edgeNum:(isMobile?2:3)});

	const [displayedDecks, setDisplayedDecks] = useState([]);

	useEffect(() => {
		if (deckList.length > 0)
		{
			page.setTotal(deckList.length);
			let nextPage = page.pageIndex;
			if (nextPage == 0) {
				nextPage = 1;
			}
			else if (page.pageIndex > Math.ceil(deckList.length / page.limit)) {
				nextPage = page.pageIndex - 1;
			}
			page.setPageIndex(nextPage);
		}
		else
		{
			page.setTotal(0);
			page.setPageIndex(0);
		}
	}, [deckList]);

	useEffect(() => {
		setDisplayedDecks(deckList.slice(page.offset, page.offset + page.limit));
	}, [deckList, page.pageIndex]);

	return (
		<div className="container-fluid h-100 p-0">
			<div
				className="h-100 d-flex flex-column p-1 gap-1"
				style={{ overflowY: "auto", overflowX: "hidden" }}
			>
				<div>
					<MyButton
						onClick={() => {setShowModal(true);}}
						text={t("MyDeck_AddDeck")}
					/>
				</div>
				<div className="d-flex flex-column h-100 p-1 overflow-y-auto">
					<MyPagination page={page} />
					<div className="list-group gap-1">
						{displayedDecks.map((deck, index) => (
							<DeckCanvas
								key={index}

								deck={deck}
							/>
						))}
					</div>
					<MyPagination page={page} />
				</div>
			</div>
			{/* モーダル */}
			{showModal && <DeckModal onClose={()=>setShowModal(false)} />}
		</div>
	);
};
